export const reportPaths = {
  REPORT: "",
  REPORT_INVENTORY: "inventory",
  REPORT_CATEGORY: "category",
  REPORT_DISCOUNT: "discount",
  REPORT_VOUCHER: "voucher",
  REPORT_SALES: "sales",
};
